'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dGroup$002dCode$0024 from "./presto.types$-Group-Code$.js";
import * as $j_presto$002etypes$0024$002dRole$002dCode$0024 from "./presto.types$-Role-Code$.js";
var $p;
/** @constructor */
function $c_Lpresto_DangerAlert$$anon$6() {
  this.aIx = null;
  this.aIv = null;
  this.aIw = false;
  this.aIt = null;
  this.aIu = false;
  this.aIy = false;
  this.aIz = false;
  this.aIx = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_DangerAlert$$anon$6 as $c_Lpresto_DangerAlert$$anon$6 };
$p = $c_Lpresto_DangerAlert$$anon$6.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_DangerAlert$$anon$6;
/** @constructor */
function $h_Lpresto_DangerAlert$$anon$6() {
}
export { $h_Lpresto_DangerAlert$$anon$6 as $h_Lpresto_DangerAlert$$anon$6 };
$h_Lpresto_DangerAlert$$anon$6.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.aIx;
});
$p.t = (function() {
  if ((!this.aIw)) {
    this.aIv = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("roles", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.aIw = true;
  }
  return this.aIv;
});
$p.ae = (function() {
  if ((!this.aIu)) {
    this.aIt = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGroup$002dCode$0024.$m_Lpresto_types$GroupCode$().jV(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Encoder$$anon$25($j_presto$002etypes$0024$002dRole$002dCode$0024.$m_Lpresto_types$RoleCode$().csa()), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.aIu = true;
  }
  return this.aIt;
});
$p.w = (function() {
  if ((!this.aIz)) {
    this.aIy = false;
    this.aIz = true;
  }
  return this.aIy;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_DangerAlert$$anon$6 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_DangerAlert$$anon$6, "presto.DangerAlert$$anon$6", ({
  Gl: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_DangerAlert$$anon$6 as $d_Lpresto_DangerAlert$$anon$6 };
//# sourceMappingURL=presto.-Danger-Alert$$anon$6.js.map
